import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ImagePresenter',
  props: {
    cssClasses: { default: "" },
    imageUrl: null,
    altText: { default: "" },
    format: { default: "jpg" },
    sizes: { default: () => ["760", "600"] },
    tallImage: { type: Boolean, default: false },
    heights: { default: () => [] },
    ignoreWidthInImageUrl: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { cssClasses: any, imageUrl: string, altText: string, format: string, sizes: string[], tallImage: boolean, heights: string[], ignoreWidthInImageUrl: boolean }



function webpKey(size: string, index: number) { return Symbol(size + index + "_webp"); }
function imageKey(size: string, index: number) { return Symbol(size + index + props.format); }

function getImageUrl(size: string, format: string): string {
    if(props.imageUrl.startsWith("data:image/")) {
        return props.imageUrl;
    }
    if (props.ignoreWidthInImageUrl) {
        const screenWidthIndex = props.sizes.indexOf(size);
        const heightToUse = props.heights[screenWidthIndex];
        const imageUrl = `${props.imageUrl}?height=${heightToUse}&format=${format}`;
        return encodeURI(imageUrl);
    }
    let imageUrl = `${props.imageUrl}?width=${size}&format=${format}`;
    if (props.tallImage) {
        const sizeNum = parseInt(size, 10);
        imageUrl += `&height=${sizeNum * 2}&mode=crop`;
    }
    return encodeURI(imageUrl);
}

function getImageMediaQuery(size: string | number, index: number): string {
    const sizeNum: number = typeof size === "number" ? size : parseInt(size, 10);
    if (index === props.sizes.length - 1) {
        return `(min-width: ${sizeNum + 1}px)`;
    } else {
        return `(max-width: ${props.sizes[index + 1]}px)`;
    }
}

function ensureSize(): string {
    if (props.sizes.length > 1) {
        return props.sizes[1];
    }
    return props.sizes[0];
}

return { __sfc: true,props, webpKey, imageKey, getImageUrl, getImageMediaQuery, ensureSize }
}

})